module.exports = __webpack_public_path__ + "static/agata-6c6a048d7551d30446640aa025709826.png";